import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { ConfettiMinimalisticIcon, FullscreenAlert } from "@/shared/ui";

export const PatientSuccessScreenAlert = () => {
  return (
    <FullscreenAlert.Root open={true}>
      <FullscreenAlert.Content>
        <FullscreenAlert.Header icon={ConfettiMinimalisticIcon}>
          <FullscreenAlert.Title>
            {t`Congrats! It looks like you'd be a great candidate for LevelsRx!`}
          </FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`We're excited to join you on this wellness journey.`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Action asChild>
            <Link to={ROUTES.HOME}>{t`Start your journey`}</Link>
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
